<template>
  <div class="vx-card">
      <grid-panel
          ref="distributionListGrid"
          :auto-size="true"
          :column-defs="distributionListColDefs"
          :data="data"
      >
        <vs-dropdown-item v-if="componentAccess.canEdit.access">
            <span
                class="flex items-center"
                @click="removeRecipients"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Remove from distribution list</span>
            </span>
        </vs-dropdown-item>
      </grid-panel>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import NotificationMixin from "../../../../components/mixins/NotificationMixin";

export default {
  name: 'UserViewDistributionList',
  components: {
    GridPanel
  },
  mixins: [CanAccessMixin, NotificationMixin],
  data() {
    return {
      urlsFn: () => [
        this.$api.users.relationship('company-distribution-lists', this.id),
        this.$api.users.relationship('facility-distribution-lists', this.id)
      ],
      data: [],
      componentAccess: {
        canEdit: {
          route: 'contact.edit',
          access: false,
        },
      },
      distributionListColDefs: [
        {
          maxWidth: 75,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Report',
          filter: 'agSetColumnFilter',
          field: 'Name',
          width: 350,
        },
        {
          headerName: 'Distribution List ID',
          filter: 'agTextColumnFilter',
          valueGetter: ({data}) => this.isCompanyReport(data)
              ? data.CompanyReport_PK
              : data.FacilityReport_PK,
          width: 350,
        },
        {
          headerName: 'Company',
          filter: 'agTextColumnFilter',
          field: 'CompanyName',
          width: 350,
        },
        {
          headerName: 'Email Address',
          filter: 'agTextColumnFilter',
          field: 'EmailAddress',
          width: 350,
        },
        {
          headerName: 'Type',
          filter: 'agSetColumnFilter',
          valueGetter: ({data}) => this.isCompanyReport(data) ? 'Entity' : 'Facility',
          width: 350,
        },
      ],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      const response = await Promise.all(this.urlsFn());
      this.data = response.flatMap(({data}) => data.data);
    },
    isCompanyReport(data) {
      return parseInt(data.ReportType) === 1;
    },
    isFacilityReport(data) {
      return parseInt(data.ReportType) === 2;
    },
    async removeRecipients() {
      const selected = this.$refs.distributionListGrid.gridApi.getSelectedNodes();

      if (selected.length === 0) {
        this.notifyError('Please select one or more lists from the grid');
        return;
      }

      this.gridLoading = true;

      const companyRemoves = selected
          .filter(({data}) => this.isCompanyReport(data))
          .map(({data}) => this.$api.companies.distributionLists.removeRecipients(
              data.CompanyReport_PK,
              [data.id]
          ));

      const facilityRemoves = selected
          .filter(({data}) => this.isFacilityReport(data))
          .map(({data}) => this.$api.facilities.distributionLists.removeRecipients(
              data.FacilityReport_PK,
              [data.id]
          ));

      try {
        await Promise.all([
            ...companyRemoves,
            ...facilityRemoves,
        ])

        this.notifySuccess('Recipient removed from lists');

        await this.fetch();
      } catch (e) {
        console.log(e);
        this.notifyError('Recipient failed to be removed. Please try again.');
      } finally {
        this.gridLoading = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
